<div class="step-page">
	<div class="step-title">
		<div class="row-wrap">
			<div class="row-left">
				<div>
					Sub Agency Management
				</div>
			</div>
		</div>
	</div>
	<div class="step-content">
		<div class="search-line">
			<input name="search" placeholder="Agency Name" [(ngModel)]="searchStr" (ngModelChange)="search()">
			<i class="glyphicons glyphicons-search"></i>
		</div>
		<div class="table-container">
			<app-common-datagrid
				#subAgencyTable
				[columns]="columns"
				[rows]="rows"
				[rowH]="40"
				columnMode="force"
				[selectedRows]="selectedRows"
				[selectionType]="undefined"
				[isPaging]="false"
				[totalNum]="rows.length"
			></app-common-datagrid>
		</div>
	</div>
</div>

<ng-template #operationsTempl let-row="row" let-column="column" let-value="value">
	<div class="operation-icons">
		<div *ngIf="row[isNewAgencyCol]">
			<i class="glyphicons glyphicons-plus-sign"
				title="Add a sub agency"
				(click)="addSubAgency(row)"></i>
		</div>
		<div *ngIf="!row[isNewAgencyCol]">
			<i class="glyphicons glyphicons-edit" title="Edit" (click)="editSubAgency(row[agencyIdCol])"></i>
		</div>
		<div *ngIf="!row[isNewAgencyCol]">
			<i class="glyphicons glyphicons-minus-sign" title="Remove the sub agency" (click)="removeSubAgency(row[agencyIdCol])"></i>
		</div>
	</div>
</ng-template>